// extracted by mini-css-extract-plugin
module.exports = {"modal":"_2Utt-","pageResetPassword":"_1MfVN","close":"OHw5W","closeIcon":"_3djsq"};